import React, { useMemo } from "react";
import { Chart, ArcElement, Tooltip } from "chart.js";
import { Doughnut } from "react-chartjs-2";

Chart.register(ArcElement);

const GREEN = "#22c55e";
const TRACK = "#1e293b";
const CARD_BG = "#111827";
const TEXT_DIM = "#64748b";

/* The percentage lives in the middle of the ring, the label right under it */
const centerText = {
  id: "centerText",
  afterDraw: function (chart, args, options) {
    const area = chart.chartArea;
    if (!area || !options) return;
    const ctx = chart.ctx;
    const x = (area.left + area.right) / 2;
    const y = (area.top + area.bottom) / 2;

    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = "600 17px Inter, sans-serif";
    ctx.fillStyle = options.color;
    ctx.fillText(options.value, x, y - 6);
    ctx.font = "400 8px Inter, sans-serif";
    ctx.fillStyle = TEXT_DIM;
    ctx.fillText(options.label, x, y + 10);
    ctx.restore();
  }
};

/* Tooltip stays local to this chart so the other charts of the app keep their own look */
const CHART_PLUGINS = [Tooltip, centerText];

const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: true,
  cutout: "62%",
  animation: { animateRotate: true, duration: 1200, easing: "easeInOutQuart" },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "#1e293b",
      titleColor: "#f1f5f9",
      bodyColor: "#94a3b8",
      borderColor: "#334155",
      borderWidth: 1,
      cornerRadius: 8,
      padding: 10,
      displayColors: false,
      callbacks: {
        label: function (context) {
          const total = context.dataset.data.reduce((sum, value) => sum + value, 0);
          const pct = total > 0 ? (context.parsed / total * 100).toFixed(1) : "0.0";
          return context.label + ": " + context.parsed + " (" + pct + "%)";
        }
      }
    }
  }
};

function ConnectivityDonut(props) {
  const { online, offline, pct } = props;
  const empty = online + offline === 0;

  const data = useMemo(() => ({
    labels: ["Reportados", "No reportados"],
    datasets: [{
      /* with no buses at all the ring still draws, just fully greyed out */
      data: empty ? [0, 1] : [online, offline],
      backgroundColor: [GREEN, TRACK],
      borderColor: [CARD_BG, CARD_BG],
      borderWidth: 4,
      borderRadius: 6,
      hoverBorderColor: [GREEN, "#334155"],
      hoverBorderWidth: 3
    }]
  }), [online, offline, empty]);

  const options = useMemo(() => Object.assign({}, CHART_OPTIONS, {
    plugins: Object.assign({}, CHART_OPTIONS.plugins, {
      tooltip: Object.assign({}, CHART_OPTIONS.plugins.tooltip, { enabled: !empty }),
      centerText: { value: pct + "%", label: "CONECTIVIDAD", color: empty ? TEXT_DIM : GREEN }
    })
  }), [pct, empty]);

  return (
    <div className="buses-stat-card donut">
      <div className="buses-donut-box">
        <Doughnut data={data} options={options} plugins={CHART_PLUGINS} />
      </div>
      <div className="buses-donut-legend">
        <span><span className="buses-donut-dot online"></span>Reportados</span>
        <span><span className="buses-donut-dot offline"></span>No reportados</span>
      </div>
    </div>
  );
}

/* The page reloads the device list every 3 s, only redraw when the counts actually moved */
export default React.memo(ConnectivityDonut, function (prev, next) {
  return prev.online === next.online &&
    prev.offline === next.offline &&
    prev.pct === next.pct;
});
